import React from "react";

export default function CloseWhite({ id, style }) {
    return <svg id={id} width="13" height="13" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M19 3.5L3 18.5" stroke="white" stroke-width="4.2" stroke-linecap="round"/>
    <path d="M18.5 19L3.5 3" stroke="white" stroke-width="4.2" stroke-linecap="round"/>
    </svg>;
}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/closeWhite.jsx